import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './sidebar.scss';
import { useNavigate } from "react-router-dom";
import AuthService from "../../services/auth.service";
import APIConfig from "../../api/APIConfig";

import {
    VStack,
    HStack,
    Text,
    Button
} from '@chakra-ui/react';


const sidebarNavItems = [
    {
        display: 'Profil',
        icon: <i className='bx bx-user'></i>,
        to: '/peserta/profile',
        section: 'profile'
    },
    {
        display: 'Dokumen',
        icon: <i className='bx bx-receipt'></i>,
        to: '/peserta/dokumen',
        section: 'dokumen'
    },
    {
        display: 'Item Tersimpan',
        icon: <i className='bx bx-bookmark'></i>,
        to: '/peserta/item-tersimpan',
        section: 'item-tersimpan'
    },
    {
        display: 'Ganti Sandi',
        icon: <i className='bx bx-key'></i>,
        to: '/peserta/change-password',
        section: 'change-password'
    },
    {
        display: 'Kembali',
        icon: <i className='bx bx-home'></i>,
        to: '/',
        section: 'home'
    },
]


const Sidebar  = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [stepHeight, setStepHeight] = useState(0);
    const sidebarRef = useRef();
    const indicatorRef = useRef();
    const location = useLocation();
    const navigate = useNavigate();

    const [fotoProfil, setFotoProfil] = useState(undefined);
    const [currentUser, setCurrentUser] = useState([]);

    const defaultFoto = 'https://w7.pngwing.com/pngs/81/570/png-transparent-profile-logo-computer-icons-user-user-blue-heroes-logo-thumbnail.png'

    const [id, setId] = useState("");


    
    useEffect(() => {
        const user = AuthService.getCurrentUser();
    
        if (user) {
            setCurrentUser(user);
            setId(user.peserta[0].idPeserta)
            console.log("cek id peserta")
            console.log(user.peserta[0].idPeserta)
        }

        console.log(user);

        setTimeout(() => {
            const sidebarItem = sidebarRef.current.querySelector('.sidebar__menu__item');
            indicatorRef.current.style.height = `${sidebarItem.clientHeight}px`;
            setStepHeight(sidebarItem.clientHeight);
        }, 50);

        getPesertaById();
    }, []);

    useEffect(() => {
        const curPath = window.location.pathname.split('/')[2];
        const activeItem = sidebarNavItems.findIndex(item => item.section === curPath);
        setActiveIndex(curPath.length === 0 ? 0 : activeItem);
    }, [location]);

    const getPesertaById = async() => {
        const user = AuthService.getCurrentUser();
        const response = await APIConfig.get(`/v1/peserta/${user.peserta[0].idPeserta}`);
        const data = await response.data

        const obj = JSON.parse(data.image);

        if (obj!=null) {
            setFotoProfil(obj.image);
        } else {
            setFotoProfil(defaultFoto);
        }
    };

    return (
        <div>
            <div className='sidebar'>
                <div className="sidebar__logo">
                    Peserta Dashboard 
                </div>
                {currentUser.peserta && currentUser.peserta.map((data) =>
                <HStack pb={8}>
                    <div
                        style={{
                            display: 'inline-block',
                            position: 'relative',
                            overflow: 'hidden',
                            borderRadius: '50%', 
                            marginLeft: '2rem',
                            marginTop: '-4rem',
                            width: '50px', 
                            height: '50px',
                            }}
                    >
                        <img style={{
                            width: 'auto', 
                            height: '100%',
                            paddingTop: '-15px',
                            }} 
                        
                            className="preview" 
                            src={fotoProfil}
                            alt="avatar" />
                    </div>
                    <VStack align='stretch'>
                        <span style={{fontSize: '18px', fontWeight: '700'}}>{data.namaPeserta}</span>
                        <span style={{fontSize: '12px', fontWeight: '400'}}>{currentUser.emailUser}</span>
                        <br></br>
                        <Button 
                            onClick={() => navigate(`/peserta/profile/upload/foto/${data.idPeserta}`)}
                            fontSize={'10px'}
                            h={'30px'}
                            marginLeft={6}
                            p={3} w={'100px'} rounded={'xl'} colorScheme='purple' variant='outline'>
                            Edit Foto
                        </Button>
                    </VStack>
                </HStack>)}
                <Text style={{fontSize: '14px', fontWeight: '700'}} pl={6} pt={4} pb={6}> Halaman Akun </Text>
                <div ref={sidebarRef} className="sidebar__menu">
                    <div
                        ref={indicatorRef}
                        className="sidebar__menu__indicator"
                        style={{
                            transform: `translateX(-50%) translateY(${activeIndex * stepHeight}px)`
                        }}
                    ></div>

                    {currentUser.peserta && currentUser.peserta.map((data) =>
                    <div className="sidebar__menudiv">
                        {sidebarNavItems.map((item, index) => (
                            <div className='abd'>
                                {item.display === 'Dokumen' ? 
                                <div>
                                    <Link to={`/peserta/dokumen/${data.idPeserta}`} key={index}>
                                        <div className={`sidebar__menu__item ${activeIndex === index ? 'active' : ''}`}>
                                            <div className="sidebar__menu__item__icon">
                                                {item.icon}
                                            </div>
                                            <div className="sidebar__menu__item__text">
                                                {item.display}
                                            </div>
                                        </div>
                                    </Link>
                                </div> : 
                                item.display === 'Item Tersimpan' ?
                                <div>
                                    <Link to={`/peserta/item-tersimpan/${data.idPeserta}`} key={index}>
                                        <div className={`sidebar__menu__item ${activeIndex === index ? 'active' : ''}`}>
                                            <div className="sidebar__menu__item__icon">
                                                {item.icon}
                                            </div>
                                            <div className="sidebar__menu__item__text">
                                                {item.display}
                                            </div>
                                        </div>
                                    </Link>
                                </div> :
                                <div>
                                    <Link to={item.to} key={index}>
                                        <div className={`sidebar__menu__item ${activeIndex === index ? 'active' : ''}`}>
                                            <div className="sidebar__menu__item__icon">
                                                {item.icon}
                                            </div>
                                            <div className="sidebar__menu__item__text">
                                                {item.display}
                                            </div>
                                        </div>
                                    </Link>
                                </div>}
                            </div>
                    ))}
                    </div>
                    )}

                   
                </div>
            </div>

            <div className='mini__sidebar'>
                <div className="mini__sidebar__logo"></div>
                {currentUser.peserta && currentUser.peserta.map((data) =>
                <HStack pb={8}>
                    <div
                        style={{
                            display: 'inline-block',
                            position: 'relative',
                            overflow: 'hidden',
                            borderRadius: '50%', 
                            marginLeft: '0rem',
                            marginTop: '-4rem',
                            width: '50px', 
                            height: '50px',
                            }}
                    >
                        <img style={{
                            width: 'auto', 
                            height: '100%',
                            paddingTop: '-15px',
                            }} 
                        
                            className="preview" 
                            src={fotoProfil}
                            alt="avatar" 
                            onClick={() => navigate(`/peserta/profile/upload/foto/${data.idPeserta}`)}/>
                    </div>
                </HStack>)}
                <div ref={sidebarRef} className="mini__sidebar__menu">
                    <div
                        ref={indicatorRef}
                        className="mini__sidebar__menu__indicator"
                        style={{
                            transform: `translateX(-50%) translateY(${activeIndex * stepHeight}px)`
                        }}
                    ></div>

                    {currentUser.peserta && currentUser.peserta.map((data) =>
                    <div>
                        {sidebarNavItems.map((item, index) => (
                            <div className='abd'>
                                {item.display === 'Dokumen' ? 
                                <div>
                                    <Link to={`/peserta/dokumen/${data.idPeserta}`} key={index}>
                                        <div className={`mini__sidebar__menu__item ${activeIndex === index ? 'active' : ''}`}>
                                            <div className="mini__sidebar__menu__item__icon">
                                                {item.icon}
                                            </div>
                                        </div>
                                    </Link>
                                </div> : 
                                <div>
                                    <Link to={item.to} key={index}>
                                        <div className={`mini__sidebar__menu__item ${activeIndex === index ? 'active' : ''}`}>
                                            <div className="mini__sidebar__menu__item__icon">
                                                {item.icon}
                                            </div>
                                        </div>
                                    </Link>
                                </div>}
                            </div>
                    ))}
                    </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
